window.PhrasesService = class {

	// Propiedad estática que actúa como caché para almacenar las frases ya cargadas,
	// evitando así solicitudes de red redundantes.
	static cache = {};

	/**
	 * Método estático asincrónico para cargar frases desde el servidor.
	 * @param {string|string[]} phrases - Una frase o un array de frases a cargar.
	 */
	static async load(phrases) {
		const self = this; // Referencia a la propia clase

		try {
			let request = []; // Array para almacenar las frases que necesitan ser solicitadas al servidor

			// Normaliza la entrada para asegurarse de que siempre sea un array
			for (let phrase of typeof(phrases) == 'string' ? [phrases] : phrases) {
				// Si la frase no está ya en caché, se agrega al array de solicitud
				if (!(phrase in self.cache)) {
					request.push(phrase);
				}
			}

			// Si hay frases que necesitan ser solicitadas
			if (request.length) {
				// Realiza una solicitud fetch al endpoint correspondiente con las frases a cargar
				let response = await fetch(`/api/fetch/phrases/${request}`);

				// Convierte la respuesta en formato JSON
				response = await response.json();

				// Agrega las frases obtenidas al caché utilizando Object.assign para mantener actualizada la propiedad cache
				Object.assign(self.cache, response);
			}
		} catch (error) {
			// Loguear unicamente sin invocar mensajes de alerta
			ErrorHandler.log(error);
		}
	}

	/**
	 * Método estático para obtener una frase del caché.
	 * @param {string} key - La clave de la frase que se desea obtener.
	 * @param {string} [defaultResponse=''] - Respuesta por defecto en caso de que la frase no esté disponible.
	 * @returns {string} - La frase correspondiente a la clave proporcionada o la respuesta por defecto.
	 */
	static get(key, defaultResponse = '') {
		try {
			const self = this; // Referencia a la propia clase

			// Intenta obtener la frase del caché utilizando la clave proporcionada
			var msg = self.cache[key];

			// Si la frase no existe en el caché, lanza un error para indicar que no está cargada o no existe
			if (!msg) {
				throw new Error("Phrase not loaded or doesn't exist: " + key);
			}

			// Si la frase obtenida es idéntica a la clave, se asume que no se encontró una traducción adecuada,
			// por lo que se devuelve la respuesta por defecto
			if (msg == key) {
				return defaultResponse;
			}

			// Sino se devuelve la frase obtenida del caché
			return msg;

		} catch (error) {

			// Loguear unicamente sin invocar mensajes de alerta
			ErrorHandler.log(error);

			// En caso de error se devuelve la respuesta por defecto
			return defaultResponse;
		}
	}
};